import { useMutation, useQueryClient } from "@tanstack/react-query";

import { petsQueryKey } from "../queries/useGetPets";
import { petTransactionsQueryKey } from "../queries/useGetPetTransactions";
import { weeklyCoinReportQueryKey } from "../queries/useGetWeeklyCoinReport";
import { guacHttpClient } from "../../lib/http";
import type { AdjustPetCoinsRequest, HttpResponse, Pet } from "../../types";

export const useAdjustPetCoins = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      ...input
    }: AdjustPetCoinsRequest & { userId: number }) => {
      const response = await guacHttpClient.post<
        Pet,
        HttpResponse<Pet>,
        AdjustPetCoinsRequest
      >(`pets/${userId}/adjust-coins`, input);
      return response.data;
    },
    retry: false,
    onSuccess: (updatedPet) => {
      queryClient.setQueryData<Pet[]>(petsQueryKey, (pets) =>
        pets?.map((pet) =>
          pet.userId === updatedPet.userId ? updatedPet : pet,
        ),
      );
      void queryClient.invalidateQueries({
        queryKey: petTransactionsQueryKey(updatedPet.userId),
      });
      void queryClient.invalidateQueries({
        queryKey: weeklyCoinReportQueryKey("THIS_WEEK").slice(0, 1),
      });
    },
  });
};
